import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Client } from "@/savaradio/common"

const initialState: {
  value: {
    client_selected?: Client,
    tab_selected: "comment" | "demand" | "advertising" | "message" | "payement"
  }
} = { value: { tab_selected: "comment" } }

const participationSlice = createSlice({
  name: "participation_slice",
  initialState,
  reducers: {
    change_client_selected: (state, action: PayloadAction<Client>) => {
      state.value.client_selected = action.payload
    },
    change_tab_selected: (state, action: PayloadAction<"demand" | "comment" | "advertising" | "message" | "payement">) => {
      state.value.tab_selected = action.payload
    }
  }
})
export const { change_client_selected, change_tab_selected } = participationSlice.actions
export const participation_slice = participationSlice.reducer